<template>
    <LoginForm class="mt-12" @login-success="handleLoginSuccess" />
</template>
<script setup lang="ts">
import LoginForm from '~/components/organisms/LoginForm.vue';
const localeRoute = useLocaleRoute()
const route = localeRoute({ name: 'account' })

const handleLoginSuccess = () => {
    // Handle successful login here
    navigateTo(route)
}


definePageMeta({
    layout: 'shop'
})

const customerStore = useCustomerStore()

// setTimeout(() => {
//    navigateTo(route)
// }, 1000)
</script>